module.exports = __webpack_public_path__ + "img/dr-ty-dworak-bluffs-family-chiropractic.ec41831a.jpg";